// Update EventEmitterService to use a proper event type
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

interface AppEvent {
    event: string;
    data?: any;
}

@Injectable({
    providedIn: 'root',
})
export class EventEmitterService {
    private eventSubject = new Subject<AppEvent>(); // Use AppEvent type
    public event$ = this.eventSubject.asObservable();

    emit(event: AppEvent): void {
        this.eventSubject.next(event);
    }
}